import {
  Button,
  Divider,
  HStack,
  Input,
  Menu,
  MenuButton,
  MenuList,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Column } from '@tanstack/react-table';
import _ from 'lodash';
import React, { useState } from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

export const TextFilter: React.FC<{
  column: Column<any, unknown>;
}> = ({ column }) => {
  const columnFilterValue = column.getFilterValue();

  const [searchText, setSearchText] = useState<string>(
    _.isString(columnFilterValue) ? columnFilterValue : '',
  );

  return (
    <Menu autoSelect={false} eventListeners={{ scroll: false, resize: true }}>
      <MenuButton fontSize="16px" color={colors.aurora[400]}>
        <FaIcon icon="chevron-down" style={{ marginLeft: '16px' }} />
      </MenuButton>
      <MenuList bg={colors.millet[50]} w="390px">
        <VStack w="100%" padding="24px">
          <Text
            textAlign="left"
            w="100%"
          >{`Filter by ${column.columnDef.header}`}</Text>
          <Input
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            bg="white"
            placeholder="Enter Receivable Id"
          />
          <Divider mt="16px" mb="24px" />
          <HStack spacing="32px" w="100%">
            <Button
              onClick={() => {
                setSearchText('');
                column.setFilterValue('');
              }}
              variant="outline"
              colorScheme="aurora"
              w="100%"
              bg="white"
            >
              Clear
            </Button>
            <Button
              colorScheme="aurora"
              onClick={() => column.setFilterValue(searchText)}
              w="100%"
            >
              Apply
            </Button>
          </HStack>
        </VStack>
      </MenuList>
    </Menu>
  );
};
